import React from 'react';
import styled from 'styled-components';
import { AcronymSection, AcronymList, AcronymItem, AcronymLetter, AcronymText } from '../../components/ThankYouStyles';

const SlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 20px;
  overflow: hidden;
  position: relative;
`;

const SlideTitle = styled.h2`
  font-family: 'Orbitron', sans-serif;
  color: #64B6FF;
  margin-bottom: 30px;
  text-align: center;
  letter-spacing: 2px;
  font-size: 1.8rem;
  text-transform: uppercase;
  position: absolute;
  top: 30px;
  left: 0;
  right: 0;
  text-shadow: 0 0 10px rgba(100, 182, 255, 0.5);
  
  &::before {
    content: '//';
    color: rgba(100, 182, 255, 0.5);
    margin-right: 10px;
  }
`;

const ContentPreview = styled.div`
  max-width: 1200px;
  width: 90%;
  margin: 0 auto;
  padding: 60px;
  border: 1px solid rgba(100, 182, 255, 0.3);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 20px rgba(100, 182, 255, 0.1);
  backdrop-filter: blur(10px);
  position: relative;
  transform: scale(1.2);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(100, 182, 255, 0.8), transparent);
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(100, 182, 255, 0.8), transparent);
  }
`;

const StyledAcronymSection = styled(AcronymSection)`
  opacity: 1 !important;
  transform: translateY(0) !important;
`;

const StyledAcronymItem = styled(AcronymItem)`
  opacity: 1 !important;
  transform: translateY(0) !important;
`;

const StyledAcronymLetter = styled(AcronymLetter)`
  opacity: 1 !important;
  transform: scale(1) !important;
`;

const StyledAcronymText = styled(AcronymText)`
  opacity: 1 !important;
  transform: translateX(0) !important;
  font-size: 1.5rem; 
`;

const PresentationSlide2 = () => {
  // Dados da sigla BIANCA
  const acronymData = [
    { letter: 'B', text: 'Bot de' },
    { letter: 'I', text: 'Inteligência' },
    { letter: 'A', text: 'Artificial para' },
    { letter: 'N', text: 'Nutrição e' },
    { letter: 'C', text: 'Controle de' },
    { letter: 'A', text: 'Agendamento' }
  ];

  return (
    <SlideWrapper>
      <SlideTitle>O Significado de BIANCA</SlideTitle>
      
      <ContentPreview>
        <StyledAcronymSection isVisible={true}>
          <AcronymList>
            {acronymData.map((item, index) => (
              <StyledAcronymItem key={index} index={index} isVisible={true}>
                <StyledAcronymLetter isVisible={true}>{item.letter}</StyledAcronymLetter>
                <StyledAcronymText index={index} isVisible={true}>{item.text}</StyledAcronymText>
              </StyledAcronymItem>
            ))}
          </AcronymList>
        </StyledAcronymSection>
      </ContentPreview>
    </SlideWrapper>
  );
};

export default PresentationSlide2;
